import "./style.scss";

import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import AddChannelButton from "components/shared/AddChannelButton";
import MessageBlock from "components/shared/MessageBlock";
import TitleSeparation from "components/shared/TitleSeparation";
import type { IChannel } from "containers/Channels/types";
import type { ITitle } from "containers/Titles/types";
import type { SetStateAction } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/store";

import { featureFlags } from "../../../config/featureFlags";
import ChannelPriceHistory from "../../Title/PriceHistory/ChannelPriceHistory";
import type { TInitialHighlightField } from "../types";
import { SpecificChannelsForm } from "./SpecificChannelsForm";

interface IPriceChannelsStep {
    stepTitle: string;
    stepSubtitle: string;
    indexStep: number;
    /**
     * Current acitve channels (toggle on)
     */
    activeChannels: number[];
    /**
     * Handle active a channel
     */
    setActiveChannels: React.Dispatch<SetStateAction<number[]>>;
    /**
     * Highlight price field condition for price field after Dilicom autocomplete
     */
    highlightField: TInitialHighlightField;
    /**
     * Reset field highlight
     */
    onResetHighlight: (fieldName: string) => void;
    /**
     * current title data
     * */
    dataTitle: ITitle | null;
}

const PriceChannelsStep = ({
    stepTitle,
    stepSubtitle,
    indexStep,
    activeChannels,
    setActiveChannels,
    dataTitle,
}: IPriceChannelsStep) => {
    const [t] = useTranslation();
    const channels: IChannel[] = useAppSelector((state) => state.channels.channels);

    const [openNewChannelModal, setOpenNewChannelModal] = useState(false);

    return (
        <>
            <h3 className="form-section-title">
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            <div className="form-fields">
                <div className="flex flex-col gap-3">
                    {featureFlags.priceHistory && (
                        <ChannelPriceHistory titleId={dataTitle?.id} channel={undefined} isEdit />
                    )}
                </div>

                <div className="price-channel-title">
                    <TitleSeparation title={t("NewTitle.PricePerChannelTitle")} />
                    <span>{t("NewTitle.PricePerChannelSubtitle")}</span>
                </div>

                {!channels.length && (
                    <MessageBlock
                        type="info"
                        text={t("NewTitle.NoChannels")}
                        link="https://helpdesk.crealo.app/fr/article/creer-un-canal-de-distribution-10p0rcj/"
                    />
                )}

                {channels.length > 0 && (
                    <div className="channels-wrapper gap-3 flex flex-col">
                        <AddChannelButton
                            label={t("NewTitle.AddNewChannel")}
                            onClick={() => setOpenNewChannelModal(true)}
                        />
                        <SpecificChannelsForm
                            onCloseNewChannelModal={() => setOpenNewChannelModal(false)}
                            onOpenNewChannelModal={openNewChannelModal}
                            activeChannels={activeChannels}
                            setActiveChannels={setActiveChannels}
                            dataTitle={dataTitle}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

/**
 * Render flag img in currency field
 */
interface IFlagTag {
    flagUrl: string | undefined;
    flagStyle?: React.CSSProperties;
    className?: string;
}
export const FlagTag = ({ flagUrl, flagStyle, className }: IFlagTag) => {
    return flagUrl ? (
        <img src={flagUrl} style={flagStyle} className={className} />
    ) : (
        <div style={flagStyle} className={className}>
            <TravelExploreIcon style={{ opacity: "0.5", height: "100%", width: "100%" }} />
        </div>
    );
};

export default PriceChannelsStep;
